function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOther(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1 0 10 10A10 10 0 0 0 10 0zm0 4a2.006 2.006 0 0 1 2 2v2.4a1.994 1.994 0 0 1-.816 1.6A2 2 0 0 1 12 11.6V14a2 2 0 0 1-4 0v-2.4a2 2 0 0 1 .814-1.6A1.992 1.992 0 0 1 8 8.4V6a2.007 2.007 0 0 1 2-2zm0 .8A1.191 1.191 0 0 0 8.8 6v2.4a1.183 1.183 0 0 0 .794 1.126V6.4h.8v3.131A1.183 1.183 0 0 0 11.2 8.4V6A1.19 1.19 0 0 0 10 4.8zm.39 5.667V13.6h-.8v-3.126A1.185 1.185 0 0 0 8.8 11.6V14a1.2 1.2 0 0 0 2.4 0v-2.4a1.184 1.184 0 0 0-.811-1.134z",
    transform: "translate(.5 .5)",
    style: {
      stroke: "transparent",
      strokeMiterlimit: 10,
      fillRule: "evenodd"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.990ba30d.svg";
export { ForwardRef as ReactComponent };